import { Card } from "react-bootstrap";
import formatCurrency from "../../utils/currencyFormmter";

const AnalyticCard = ({ title, value, icon, color, showCurrency, showBorder }) => {
    const showCurrencySymbol = showCurrency !== undefined ? showCurrency : true;
    const showCardBorder = showBorder !== undefined ? showBorder : false;
  return (
    <>
        <Card className={"shadow-sm " + (showCardBorder ? "" : "border-0") + (" bg-"+color)}>
            <div className="d-flex align-items-center gap-2 px-2 py-4">
                <div className="icon">
                </div>
                <div>
                    {
                        showCurrencySymbol ? (
                            <h3>{formatCurrency(value).with_currency}</h3>
                        ) : (
                            <h3>{formatCurrency(value).formatted}</h3>
                        )
                    }
                    <p>
                        <img src={icon} alt={icon} />
                        {title}
                    </p>
                </div>
            </div>
        </Card>
    </>
  );
}
export default AnalyticCard;